import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Chip from '@mui/material/Chip';
import { advancedOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { PaymentFrequencyException } from '../../../../Api/PaymentFrequencyException/PaymentFrequencyExceptionApi';
import { chipStyles } from '../../../../utils/helpers';

export const DefaultPaymentFrequencyExceptionGridColumnDefs: (
  deleteRow: (id: string) => void
) => GridSingleSelectColDef[] = (deleteRow) => [
  {
    headerName: 'Supplier',
    field: 'supplierName',
    flex: 3,
    minWidth: 240,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<PaymentFrequencyException>) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.supplierSfid}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.supplierName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'Payment Frequency',
    field: 'paymentFrequency',
    flex: 3,
    minWidth: 170,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams) => {
      const value = params.value as string;
      if (!value) return '';
      return (
        <Chip
          label={value}
          size="small"
          sx={chipStyles(value)}
          title={value}
        />
      );
    }
  },
  {
    field: 'actions',
    headerName: '',
    width: 80,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    hideable: false,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <button
        className="-mt-[0.125rem] align-top"
        onClick={() => deleteRow(params.row.id)}>
        <DeleteIcon color="buttonGrey" />
      </button>
    )
  }
];
